import axios from "axios";
import Vue from "vue";
// axios.defaults.withCredentials = true
export default new (function httpClients() {
  axios.create({
    baseURL: "http://dev.hkbid-icm2030.org/",
    timeout: 3000,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  });
  this.host = "/api";

  this.protocol = {
    jb_list: this.host + "/H5Api/jb_list", // 嘉宾列表 
    statistics_add: this.host + "/VisApi/statistics_add", // 嘉宾列表 
    getIP: this.host + "/LoginApi/getIP", // 获取IP
    message_add: this.host + "/VisApi/message_add", // 添加留言
    news_list: this.host + "/H5Api/news_list", // 新闻列表

  };

  this.get_token_list = function (symbols) {
    let wallets = {};
    return this.get_assets()
      .then((result) => {
        if (result.code === 200) {
          for (let i = 0; i < result.data.length; ++i) {
            let item = result.data[i];
            wallets[item.symbol] = item;
          }
          return this.get_rate({
            orgCoin: symbols,
            targetCoin: "GBP",
          });
        }
        return result;
      })
      .then((result) => {
        if (result.code === 200) {
          let rates = {};
          for (let i = 0; i < result.data.length; ++i) {
            let item = result.data[i];
            rates[item.orgCoin] = item;
          }
          return {
            code: 200,
            wallets,
            rates,
          };
        }
        return result;
      });
  };

  this.to_withdraw = function (params) {
    params.fromId = Vue.prototype.$config.getUser().uuid;
    return this.post(this.protocol.to_withdraw, params);
  };

  function query(key, data) {
    if (Array.isArray(data)) {
      let r = [];
      data.forEach((str) => {
        if (str) {
          r.push(encodeURIComponent(key) + "[]=" + encodeURIComponent(str));
        }
      });
      return r.join("&");
    }
    return encodeURIComponent(key) + "=" + encodeURIComponent(data);
  }

  function queryString(params) {
    return (
      "?" +
      Object.keys(params)
        .map(function (key) {
          return query(key, params[key]);
        })
        .join("&")
    );
  }

  function noqueryString(params) {
    return Object.values(params).join("/");
  }

  this.sendGet = function (url) {
    return axios({
      url: url,
      type: "GET",
      dataType: "json",
      // crossDomain: true,
      // baseURL: "https://qcfa.chinasay.cn/",
      // xhrFields: {
      //   withCredentials: true
      // },
      contentType: "multipart/json",
    }).then((response) => {
      return response.data;
    });
  };
  this.getHeaders = function () {
    let sign = Vue.prototype.$config.getSignature();
    if (sign) {
      return {
        "access-key": sign.access_key,
        nonce: sign.nonce,
        signature: sign.signature,
        timestamp: sign.timestamp,
      };
    } else {
      return {};
    }
  };
  this.sendPost = function (url, options) {
    return axios({
      method: "POST",
      url: url,
      // crossDomain: true,
      // xhrFields: {
      //   withCredentials: true
      // },
      data: options,
      contentType: "application/json",
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  };
  this.formData = function (params) {
    if (typeof params === "object") {
      let formData = new FormData();
      let postDataInstances = [ArrayBuffer, Blob, Document, FormData, File];
      for (let key in params) {
        if (
          params[key] &&
          typeof params[key] === "object" &&
          postDataInstances.indexOf(params[key].constructor) === -1
        ) {
          formData.append(key, JSON.stringify(params[key]));
        } else {
          formData.append(key, params[key]);
        }
      }
      return formData;
    }
    return params;
  };
  this.get = function (url, params) {
    if (typeof params !== "object") {
      return this.sendGet(url);
    } else {
      if (params.mode === "noquery") {
        delete params.mode;
        return this.sendGet(url + noqueryString(params));
      } else {
        return this.sendGet(url + queryString(params));
      }
    }
  };
  this.post = function (url, params) {
    return this.sendPost(url, params);
  };


  this.jb_list = function (params) {
    // 嘉宾列表
    return this.get(this.protocol.jb_list, params);
  };
  this.statistics_add = function (params) {
    return this.post(this.protocol.statistics_add, params);
  }
  this.getIP = function (params) {
    return this.get(this.protocol.getIP, params);
  }
  this.message_add = function (params) {
    return this.post(this.protocol.message_add, params);
  }
  
  this.news_list = function (params) {
    return this.get(this.protocol.news_list, params);
  }
  
})();



// WEBPACK FOOTER //
// ./src/utils/http.js